export default __webpack_public_path__ + "static/media/Neophyte's Bracers of Consumed Souls.7c2377eb.jpg";